export const LOCAL_STORAGE = {
  currentDebateId: 'currentDebateId',
  currentDebateTitle: 'currentDebateTitle',
  refreshToken: 'refreshToken',
  token: 'token',
  currentChallengeId: 'currentChallengeId',
  toGenerateWithAI: 'toGenerateWithAI',
} as const;
